export default __webpack_public_path__ + "static/media/bonus-received-ico.fc628bd9.svg";